import { TeacherJSON, ValidationResult } from './JSONSchema';

export class JSONValidator {
  public static validate(input: any): ValidationResult {
    const errors: string[] = [];
    const warnings: string[] = [];

    if (!input || typeof input !== 'object') {
      return {
        valid: false,
        errors: ['Invalid JSON format. Expected a JSON object.'],
        warnings: [],
      };
    }

    if (!input.title || typeof input.title !== 'string') {
      errors.push("Missing required field 'title' (string).");
    }

    if (input.construction) {
      if (typeof input.construction !== 'string') {
        errors.push("Field 'construction' must be a string identifier (e.g. '90deg', 'incenter', 'hexagon').");
      }
    } else if (input.steps && Array.isArray(input.steps)) {
      if (input.steps.length === 0) {
        errors.push("Field 'steps' must be a non-empty array of step objects.");
      } else {
        input.steps.forEach((step: any, idx: number) => {
          if (!step.title) {
            warnings.push(`Step ${idx + 1} is missing a 'title'.`);
          }
          if (!step.actions && !step.action) {
            errors.push(`Step ${idx + 1} ('${step.title || 'unnamed'}') must contain an 'action' or 'actions' object.`);
          }
        });
      }
    } else {
      errors.push("Teacher JSON must specify either a 'construction' identifier or a 'steps' array.");
    }

    return {
      valid: errors.length === 0,
      errors,
      warnings,
    };
  }
}
